/**
 * Version: 1.2.5

	1.2.5
	convert to export bundle

	1.2.4
	set invalid single $ field

	1.2.3
	added maybe_print_errors()
	added checkbox required validation

	1.2.2
	added .is-valid
	fix required validation

 */

let $ = jQuery

class Field {
	selector = null
	$el = null
	valid = true
	error_messages = []
	validations = []

	constructor() {

	}

	check() {
		// if already invalid, skip
		if ( ! this.valid ) {
			return;
		}
		if ( ! this.$el.hasClass('initialized') && ( ! this.$el.is( ':visible' ) || this.$el.is( ':disabled' ) ) ) {
			return
		}

		this.$el.parent().addClass('was-validated')

		if ( this.$el.is(':invalid' ) || this.$el.attr( 'aria-invalid' ) == 'true' ) {
			this.set_invalid()
			return;
		}

		let field_instance = this
		field_instance.validations.forEach( function ( validation ) {

			let check = null, validation_slug = null
			if ( typeof validation == 'object' ) {
				validation_slug = validation.slug
				check = validation.is_valid( field_instance )
			} else {
				validation_slug = validation
				check = Checks[validation_slug].is_valid( field_instance )
			}

			if ( check !== true ) {
				field_instance.set_invalid(validation_slug, check)
			} else {
				field_instance.$el.parent().addClass('is-valid')
				field_instance.$el.addClass('is-valid')
			}
		} )
	}
	clear_validation() {
		this.valid = true
		this.error_messages = []
		this.$el[0].setCustomValidity( '' )
		this.$el.removeAttr( 'aria-invalid' )
		this.$el.parent().removeClass('was-validated is-invalid is-valid')
		this.$el.removeClass('is-invalid is-valid')
	}
	set_invalid(validation = null, message = null) {
		this.$el.parent().addClass('was-validated')

		this.valid = false
		if ( validation ) {
			this.$el[0].setCustomValidity( validation )
		}
		// this.$el.attr( 'aria-invalid', true )
		this.$el.parent().addClass( 'is-invalid' )
		this.$el.addClass( 'is-invalid' )
		if ( typeof message == "string" ) {
			this.error_messages.push( message )
		}
	}

}

export default class {
	fields = {}
	$wrapper = null

	constructor( args = {fields: [], $wrapper: null} ) {
		let instance = this
		instance.fields = {}
		instance.$wrapper = args.$wrapper

		let parse_fields = function () {
			args.fields.forEach( function ( item ) {
				let validations = ['required']
				let selector = ''
				if ( typeof item == 'object' ) {
					selector = item.selector
					validations = item.validations
				} else {
					selector = item
				}
				let $field = $( selector, instance.$wrapper )
				if ( !$field.length ) {
					return;
				}

				for ( let elem of $field ) {
					let field = new Field()
					field.$el = $( elem )
					field.selector = selector
					field.validations = validations

					instance.fields[uuidv4()] = field
				}

			} )
		}

		parse_fields()
	}

	maybe_print_errors() {
		let instance = this
		XKIT_Utils.remove_toasts( instance.$wrapper ) 
		if ( !instance.check() ) {
			let msgs = [xkit_i18n.invalid_form_fields].concat( instance.get_error_messages() );
			XKIT_Utils.toast( {
				message: `<ul class="list-unstyled"><li>${msgs.join( '</li><li>' )}</li></ul>`,
				$container: instance.$wrapper
			} )
			let $first_invalid_field = instance.get_invalid_fields()[0]
			XKIT_Utils.scroll_to_element( $first_invalid_field.$el );
			return false;
		}
	}

	check() {
		this.clear()

		// this.$wrapper.addClass('was-validated')

		Object.entries( this.fields ).forEach( function ( [index, field] ) {
			field.check()
		} )

		return this.is_valid()
	}
	get_invalid_fields() {
		let fields = []

		for ( let [index, field] of Object.entries( this.fields ) ) {
			if ( !field.valid ) {
				fields.push( field )
			}
		}

		return fields
	}
	get_error_messages() {
		let msgs = []

		for ( let field of this.get_invalid_fields() ) {
			for ( let error_message of field.error_messages ) {
				msgs.push( error_message )
			}
		}

		return msgs
	}

	is_valid() {
		// if ( $('.was-validated *:invalid, .was-validated [aria-invalid="true"]', this.$wrapper).length ) {
		// 	console.log( $('*:invalid, [aria-invalid="true"]', this.$wrapper ) )
		// 	return false;
		// }
		if ( this.get_invalid_fields().length ) {
			console.log( this.get_invalid_fields() )
			return false;
		}
		return true
	}
	clear() {
		// this.$wrapper.removeClass('was-validated')

		Object.entries( this.fields ).forEach( function ( [index, field] ) {
			field.clear_validation()
		} )
	}

	set_invalid( $fields ) {
		// this.$wrapper.removeClass('was-validated')

		if ( !Array.isArray( $fields ) ) {
			$fields = [$fields]
		}

		for ( let $field of $fields ) {
			for ( let elem of $field ) {
				let field = new Field()
				field.$el = $( elem )
				// field.selector = selector
				// field.validations = validations
				field.set_invalid()
			}

		}
	}

	// static public method to clear a field state
	clear_fields( $fields ) {
		// this.$wrapper.removeClass('was-validated')

		if ( !Array.isArray( $fields ) ) {
			$fields = [$fields]
		}

		for ( let $field of $fields ) {
			for ( let elem of $field ) {
				let field = new Field()
				field.$el = $( elem )
				// field.selector = selector
				// field.validations = validations
				field.clear_validation()
			}

		}
	}
}

let Checks = {}
Checks['required'] = {
	is_valid: function( field ) {
		if ( field.$el.is(':checkbox') && ! field.$el.is(':checked') ) {
			return false
		} else if ( 
			field.$el.val() == null 
			|| ( typeof field.$el.val() === 'string' && field.$el.val().trim() == '' ) 
			// also check if multiselect - array of values - must have at least one not empty value
			|| ( Array.isArray( field.$el.val() ) && field.$el.val().every( function ( value ) {
				return value == null || ( typeof value === 'string' && value.trim() == '' )
			} ) )
		) {
			return false
		}
		return true
	}
}

// <editor-fold desc="uuidv4">
let uuidv4 = function(options, buf, offset) {

	options = options || {};
	const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

	rnds[6] = rnds[6] & 0x0f | 0x40;
	rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

	if (buf) {
		offset = offset || 0;

		for (let i = 0; i < 16; ++i) {
			buf[offset + i] = rnds[i];
		}

		return buf;
	}

	return unsafeStringify(rnds);
}

const rnds8Pool = new Uint8Array(256); // # of random values to pre-allocate

let poolPtr = rnds8Pool.length;
function rng() {
	if (poolPtr > rnds8Pool.length - 16) {
		// Crypto.randomFillSync(rnds8Pool);
		crypto.getRandomValues(rnds8Pool);
		poolPtr = 0;
	}

	return rnds8Pool.slice(poolPtr, poolPtr += 16);
}

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
	byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
	// Note: Be careful editing this code!  It's been tuned for performance
	// and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
	return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
// </editor-fold>
